// react
import React from "react";

// react-icons
import { AiOutlineBarChart } from "react-icons/ai";

// mui
import {
  Box,
  Card,
  Chip,
  Divider,
  Tooltip,
  Typography,
  Skeleton,
  Grid,
} from "@mui/material";

//styles
import useStyles from "./stringCardStyles";

// Card-Header
const CardHeader = (props) => {
  var date = props.first.data_received_time;
  const mytime = date.toString();

  // function to get the current time from browser
  var browserDateTime = new Date();
  const browserDate = browserDateTime.toString().slice(4, 15);

  return (
    <div>
      <Grid container sx={{ height: "20%" }}>
        <Grid item container sx={{ padding: "10px" }}>
          <Grid
            item
            xs
            zeroMinWidth
            sx={{ display: "flex", justifyContent: "flex-start" }}
          >
            {props.loadingData ? (
              <Skeleton width="30px" />
            ) : props.first.attribute_name === null ? (
              props.first.attribute_key.length > 14 ? (
                <Tooltip title={props.first.attribute_key} placement="bottom">
                  <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
                    {props.first.attribute_key.slice(0, 14) + "..."}
                  </Typography>
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
                  {props.first.attribute_key}
                </Typography>
              )
            ) : props.first.attribute_name.length > 14 ? (
              <Tooltip title={props.first.attribute_name} placement="bottom">
                <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
                  {props.first.attribute_name.slice(0, 14) + "..."}
                </Typography>
              </Tooltip>
            ) : (
              <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
                {props.first.attribute_name}
              </Typography>
            )}
          </Grid>
          <Grid item>
            {mytime.slice(0, 11) !== browserDate &&
              props.first.value !== "Data Unavailable" && (
                <Chip
                  variant="outlined"
                  label="outdated"
                  color="success"
                  sx={{ height: "20px", fontFamily: "Poppins, sans-serif" }}
                />
              )}
          </Grid>
        </Grid>
      </Grid>
      <Divider />
    </div>
  );
};

// Card-Container
const CardContainer = (props) => {
  return (
    <div>
      {props.second.value !== "Data Unavailable" ? (
        <Box
          sx={{
            height: "60%",
            margin: "79px auto",
            width: "100%",
            textAlign: "center",
          }}
        >
          {props.second.value.length > 16 ? (
            <Tooltip title={props.second.value} placement="bottom">
              <Typography variant="h6" color="#007fff">
                {props.second.value.slice(0, 16) + "..."}
              </Typography>
            </Tooltip>
          ) : (
            <Typography variant="h6" color="#007fff">
              {props.second.value}
            </Typography>
          )}
        </Box>
      ) : (
        <Box
          sx={{
            height: "60%",
            margin: "72px auto",
            width: "100%",
            textAlign: "center",
          }}
        >
          <Box>
            <AiOutlineBarChart
              style={{ fontSize: "14px", fontWeight: "1000", color: "black" }}
            />
            <Typography variant="h6" color="#6c757d" sx={{ fontSize: "14px" }}>
              {props.second.value}
            </Typography>
          </Box>
        </Box>
      )}
    </div>
  );
};

// Card-Footer
const CardFooter = (props) => {
  var dateTime = props.third.data_received_time.toString();
  return (
    <div>
      <Divider />
      <Grid
        container
        sx={{
          height: "20%",
          display: "flex",
          justifyContent: "end",
          alignContent: "center",
          padding: "7px",
        }}
      >
        {props.loadingData ? (
          <Skeleton width={195} />
        ) : (
          <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
            Received On : {dateTime.slice(0, 23)}
          </Typography>
        )}
      </Grid>
    </div>
  );
};

// StringCard Component
const StringCard = (props) => {
  const classes = useStyles();
  return (
    <div>
      <Card
        className={classes.root}
        sx={{
          borderRadius: 2,
          width: "300px",
          height: "17em",
          margin: "auto",
        }}
      >
        <CardHeader first={props.value} loadingData={props.loading} />
        <CardContainer second={props.value} loadingData={props.loading} />
        <CardFooter third={props.value} loadingData={props.loading} />
      </Card>
    </div>
  );
};
export default StringCard;
